export default node => {
  return node
}
